<ng-container>
  <div>CustomZ</div>
</ng-container>
